/**
 * React Query Key Factories
 *
 * Hierarchical query keys for the tasks domain to enable granular cache invalidation.
 */

import type { TaskListParams, EntityTaskScope } from '../api/tasks';

export const taskKeys = {
  all: ['tasks'] as const,
  lists: () => [...taskKeys.all, 'list'] as const,
  list: (params?: TaskListParams) => [...taskKeys.lists(), params] as const,
  summary: () => [...taskKeys.all, 'summary'] as const,
  details: () => [...taskKeys.all, 'detail'] as const,
  detail: (id: string) => [...taskKeys.details(), id] as const,
  assignableUsers: (searchQuery?: string) =>
    [...taskKeys.all, 'assignable-users', searchQuery ?? ''] as const,
  byEntity: (scope: EntityTaskScope) =>
    [...taskKeys.all, 'by-entity', scope.pluginId, scope.entityType, scope.entityId] as const,
};
